function game_5002()
{

}

game_5002.odd_map  = {
  "H":[0,0,30,120,200],
  "G":[0,0,20,80,160],
  "F":[0,0,16,40,120],
  "E":[0,0,12,30,80],
  "D":[0,0,8,20,40],
  "C":[0,0,8,20,40],
  "B":[0,0,4,10,20],
  "A":[0,0,4,10,20],
};

game_5002.mul_array  = [
  [1,2,3,5],
  [2,4,6,10]
]


export {
  game_5002
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5002.js